import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import {createSelector} from 'reselect';
import queryString from 'query-string';

import * as styles from '../../styles';
import {request , incrementPending , decrementPending} from '../../containers/actions';
import {refresh as paginatorRefresh} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import schoolsFiltersSelectorGenerator from '../schools/filters';
import examinationsFiltersSelectorGenerator from '../examinations/filters';
import Instructions from './instructions';
import Invoice from './invoice';
import WrappingInvoice from './wrapping_invoice';
import AnswerSheets from './answer_sheets';
import Barcode from '../examinations/barcode';
import EssayBarcode from '../examinations/essay_barcode';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import QRCode from 'qrcode';
import { PrintMyContent } from '../../utilities/print';


export default class Schools extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
    }

    state = {
        examinations: [],
        readyToPrint: false,
        printType:null,
        printTitle:'',

        rightMargin:null,
        upMargin:null,
    }

    constructor(){
        super();
        this.makeReadyToEdit = this.makeReadyToEdit.bind(this);
        this.printIframe = this.printIframe.bind(this);
    }

    makeReadyToEdit(printType,printTitle){
        var pf = this.refs.printFrame;
        pf.style.height = "300px";

        this.setState({readyToPrint:true,printType:printType,printTitle:printTitle});
    }



    /** 1 for default printer, 20 for a4 js, 25 for a5 js*/
    printIframe(type , title = "",maxPageTo=999999999,closeThePrintPage=true,printScale=2){
        debugger;
        console.log("typeeee",type)
        const win = this.refs.printFrame.contentWindow;

        function finished(){
            if(closeThePrintPage){
                this.refs.printFrame.style.height = "0";
                this.setState({readyToPrint:false});
            }
            cs.dispatch(incrementPending());
        }
        finished = finished.bind(this);

        if(type === 14){
            type = 20 ;
        }
        else if(type === 15){
            type = 25 ;
        }

        if (type === 1) { // Any type native printer window
            win.print();
        }
        if (type === 10) { // Damaged!!
            var cs = this.context.store;
            cs.dispatch(decrementPending());
            var pf = this.refs.printFrame;
            pf.style.width = "14.8cm";
            pf.style.height = "21cm";
            // pf.style.opacity = "0";

            var child = win.document.children[0];
            var pageCount = child.children[1].children[0].children[0].children.length;
            var pdf = new jsPDF("p", "cm", "a5");
            var pageWidth_cm = pdf.internal.pageSize.width * printScale;
            var pageHeight_cm = pdf.internal.pageSize.height * printScale;
            var pageWidth_px = pageWidth_cm * 37.7952755906;
            var pageHeight_px = pageHeight_cm * 37.7952755906;
            console.log("pageWidth_px",pageWidth_px)
            console.log("pageHeight_px",pageHeight_px)
            var canvas = "";
            let myPromise = new Promise(function (myResolve) {
                var openedThreads = 0;
                var i = 0;
                for(var ii = 0 ; ii<5 ; ii++)
                {
                    selectHtml();
                }
                function selectHtml(){
                        var myHtml = child.children[1].children[0].children[0].children[i];
                        openedThreads++;
                        i++;
                        console.log("selectedHtml is : " , i);
                        HtmlToPdf(myHtml,i,jobDone); 
                }
                function HtmlToPdf(myHtml , i, onDone = () => { }){ 
                    console.log("canvas started is : " , i);
                    html2canvas(myHtml, { 
                        foreignObjectRendering: true,
                        scale: printScale,
                    }).then(canvas => {
                        console.log("canvas generated is : " , i);
                        var ctx = canvas.getContext('2d');
                        var ImageData = ctx.getImageData(0, 0, pageWidth_px, pageHeight_px);
                        var img = getImageURL(ImageData, pageWidth_px, pageHeight_px);
    
                        if (i !== 0) {
                            pdf.addPage();
                        }
                        pdf.setPage(i + 1);
                        pdf.addImage(img, 'JPEG', 0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, null, "FAST");
                        // if (i + 1 == 1) {
                        //     pdf.save(title);
                        //     myResolve();
                        // }
                        setTimeout(onDone,0);
                    });
                }
                function jobDone(){
                    openedThreads--;
                    if(openedThreads==0 && pageCount+1 >= pageCount)
                    {
                        pdf.save(title);
                        myResolve();
                        DelayTest('Done PDF');
                    }
                    else
                    {
                        selectHtml();
                    }
                }
                
            function getImageURL(imgData, width, height) {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                canvas.width = width;
                canvas.height = height;
                ctx.putImageData(imgData, 0, 0);
                return canvas; //image URL
            }
            });
            
            myPromise.then(finished);
        }
        if (type === 20 || type === 25) { // Correct JS for A4 and A5
            var cs = this.context.store;
            cs.dispatch(decrementPending());
            // var pf=this.refs.printFrame;
            
            var child = win.document.children[0];
            debugger;

            // let myPromise = new Promise(PrintMyContent);
            PrintMyContent(this.refs.printFrame,finished,type,printScale,maxPageTo,title)
            // "Consuming Code" (Must wait for a fulfilled Promise)
            // myPromise.then(finished);

        }
        if(type == 2) { // Damaged
            var cs = this.context.store;
            cs.dispatch(decrementPending());
            var pf=this.refs.printFrame;
            pf.style.width = "21cm";
            pf.style.height = "29.7cm";
            // pf.style.opacity = "0";
            
            var child = win.document.children[0];

            let myPromise = new Promise(function (myResolve) {
                var canvas_array = [];
                // var child = document.getElementsByTagName("body")[0];
                var pageCount = child.children[1].children[0].children[0].children[0].children.length;
                var pages = [];
                while (child.children[1].children[0].children[0].children.length > 0) {
                    var currentChild = child.children[1].children[0].children[0].children[0];
                    child.children[1].children[0].children[0].removeChild(currentChild);
                    pages.push(currentChild);
            }
            var pdf = new jsPDF("p", "cm", "a4");
            var pageWidth_cm = pdf.internal.pageSize.width * printScale;
            var pageHeight_cm = pdf.internal.pageSize.height * printScale;
            var pageWidth_px = pageWidth_cm * 37.7952755906;
            var pageHeight_px = pageHeight_cm * 37.7952755906;
            const child_len = pages.length;
                var iCounter = -1;
                var openedThreads = 0;
                for(var ii = 0 ; ii<5 ; ii++)
                {
                    callForEachChildren();
                }
                function callForEachChildren() {

                        iCounter++;
                        if (iCounter < child_len) {
                            if (iCounter > 0) {
                                child.children[1].children[0].children[0].removeChild(pages[iCounter - 1]);
                            }
                            child.children[1].children[0].children[0].appendChild(pages[iCounter]);
                            console.log("Precent: " + iCounter + "/" + child_len)
                            //  if(iCounter > 1){
                            //     pdf.save(title);
                            //  }
                            openedThreads++
                            ToCan(child , iCounter, canvasDone);
                        }
                }
                function canvasDone(){
                    openedThreads--;
                    if(openedThreads==0 && iCounter+1 >= child_len)
                    {
                        pdf.save(title);
                        myResolve();
                        DelayTest('Done PDF');
                    }
                    else
                    {
                        callForEachChildren()
                    }
                }

                function ToCan(myHTMLPage,counter, onDone = () => { }) {
                    console.log("Canvas started : "+counter);
                    html2canvas(myHTMLPage, {
                            foreignObjectRendering: false,
                            scale: printScale,
                    }).then(canvas => {

                            //این تو نمیاد که کنوس رو نگه دارم
                            // canvas_array.push(canvas);
                            console.log("Canvas done : "+counter);
                            ToPdf(canvas,counter)
                            setTimeout(onDone,0);
                    });
                    console.log("Canvas wait : "+counter);
            }

            function ToPdf(canvas , counter) {

                            var user_pageCount = counter *pageCount;

                            for (var j = 0; j < pageCount; j++) {
                                    var sy = pageHeight_px * j;
                                    var ctx = canvas.getContext('2d');
                                    var ImageData = ctx.getImageData(0, sy, pageWidth_px, pageHeight_px);
                                    var img = getImageURL(ImageData, pageWidth_px, pageHeight_px);

                                    if(j!==0 || counter!==0){
                                        pdf.addPage();
                                    }
                                    pdf.setPage(j + 1 + user_pageCount);
                                    pdf.addImage(img, 'JPEG', 0, 0, pdf.internal.pageSize.width, pdf.internal.pageSize.height, null, "FAST");
                            }
            }

                        function getImageURL(imgData, width, height) {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                canvas.width = width;
                canvas.height = height;
                ctx.putImageData(imgData, 0, 0);
                return canvas; //image URL
            }

            });

            // "Consuming Code" (Must wait for a fulfilled Promise)
            myPromise.then(finished);


        }
        var delayStartTime = new Date().getTime();
        function DelayTest(lable=''){
            console.log(lable+"  Tooks : "+(new Date().getTime()-delayStartTime));
            delayStartTime = new Date().getTime();
        }

    }


    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}

    listFieldsSelector = createSelector(
        [
            (__, state) => state.examinations,
        ],
        examinations => [
            {field: 'id', label: window.gettext('ID')},
            {field: 'name', label: window.gettext('Name')},
            {field: item => _.map(item.levels, level => level.title).join(window.gettext(',') + ' '), label: window.gettext('Level')},
            {field: item => item.city ? item.city.name : '-' , label: window.gettext('City')},
            {field: item => item.city ? item.city.region_display : '-', label: window.gettext('Region')},
            {field: item => item.gender === 1 ? window.gettext('Male') : window.gettext('Female'), label: window.gettext('Gender')},
            {field: 'phone_number', label: window.gettext('Phone')},
            {
                field: item => item.category ? item.category.title : '',
                label: window.gettext('Category'),
            },
            ...examinations.length
                ? [{
                    fields: item => [
                        () => <button
                            key='instructions'
                            style={{
                                ...styles.button,
                                backgroundColor: 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.setState({fontSize: 9, printSize: 'A4', printOrientation: 'Portrait'}, async () => {
                                    await window.wait(500);
                                    const win = this.refs.printFrame.contentWindow;
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(
                                        <Instructions school={item} onLoad={win.print}/>,
                                        win.document.getElementById('content'),
                                    );
                                });
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext('Instructions')}
                        </button>,
                        () => <button
                            key='invoice'
                            style={{
                                ...styles.button,
                                backgroundColor: 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.setState({fontSize: 9, printSize: 'A5', printOrientation: 'Landscape'}, async () => {
                                    await window.wait(500);
                                    const win = this.refs.printFrame.contentWindow;
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(
                                        <Invoice school={item} onLoad={win.print}/>,
                                        win.document.getElementById('content'),
                                    );
                                });
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext('Invoice')}
                        </button>,
                        () => <button
                            key='wrapping-invoice'
                            style={{
                                ...styles.button,
                                backgroundColor: 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.setState({fontSize: 9, printSize: 'A4', printOrientation: 'Landscape'}, async () => {
                                    await window.wait(500);
                                    const win = this.refs.printFrame.contentWindow;
                                    let counter = 0;
                                    const print = () => {
                                        counter++;
                                        if (counter === examinations.length)
                                            win.print();
                                    };
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(
                                        <span>
                                            {_.map(examinations, examination => <WrappingInvoice
                                                key={examination.id}
                                                examination={examination}
                                                school={item}
                                                onLoad={print}
                                            />)}
                                        </span>,
                                        win.document.getElementById('content'),
                                    );
                                });
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext('Wrapping Invoice')}
                        </button>,
                        () => <button
                            key='answer-sheets'
                            style={{
                                ...styles.button,
                                backgroundColor: 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.setState({fontSize: 9, printSize: 'A5', printOrientation: 'Portrait'}, async () => {
                                    await window.wait(500);
                                    const win = this.refs.printFrame.contentWindow;
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(
                                        <AnswerSheets examinations={examinations} school={item} onLoad={win.print}/>,
                                        win.document.getElementById('content'),
                                    );
                                });
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext('Answer Sheets')}
                        </button>,
                    ],
                    label: window.gettext('All'),
                    labels: ['', '', '', ''],
                }]
                : [],
            ..._.map(examinations, examination => ({
                fields: item => [
                    () => <div style={{width: '1em', display: 'inline-block'}}></div>,
                    () => <button
                        key='invoice'
                        style={{
                            ...styles.button,
                            backgroundColor: 'transparent',
                            padding: '.25em',
                            boxSizing: 'border-box',
                        }}
                        onClick={event => {
                            event.stopPropagation();
                            this.setState({fontSize: 9, printSize: 'A4', printOrientation: 'Landscape'}, async () => {
                                await window.wait(500);
                                const win = this.refs.printFrame.contentWindow;
                                ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                ReactDom.render(
                                    <WrappingInvoice
                                        examination={examination}
                                        school={item}
                                        onLoad={win.print}
                                    />,
                                    win.document.getElementById('content'),
                                );
                            });
                        }}
                        onMouseUp={({target}) => target.blur()}>
                        {window.gettext('Wrapping Invoice')}
                    </button>,
                    () => <button
                        key='barcodes'
                        style={{
                            ...styles.button,
                            backgroundColor: 'transparent',
                            padding: '.25em',
                            boxSizing: 'border-box',
                        }}
                        onClick={event => {
                            event.stopPropagation();
                            this.setState({
                                fontSize: 9,
                                printSize: examination.paper_type === 14 ? 'A4' : 'A5',
                                printOrientation: 'Portrait',
                            }, async () => {
                                await window.wait(500);
                                const win = this.refs.printFrame.contentWindow;
                                const response = await this.context.store.dispatch(request(
                                    '/registration/?school=' +
                                    item.id + '&examination=' + examination.id + '&limit=100000',
                                ));
                                const data = response.results.sort((a,b)=>a.student.lastname > b.student.lastname);
                                if (data.length === 0) {
                                    alert(window.gettext('No student is registered for these examinations.'));
                                    return;
                                }
                                for(var i = 0 ; i < data.length ; i++){
                                    var barcodeURL = await QRCode.toDataURL(data[i].id.toString(),{
                                        typeNumber: -1,
                                        margin: 0,
                                        errorCorrectionLevel: 'Q',
                                    });
                                    data[i].barcodeURL = barcodeURL ;
                                }
                                ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                console.log("this.props.store : ",this.props.store);
                                console.log("Start Render")
                                console.log(examination.paper_type,'examination.paper_type')
                                ReactDom.render(<span>
                                    {_.map(
                                        _.sortBy(data, ['student.clazz.id', 'student.lastname', 'student.firstname']),
                                        row =>
                                        row.online===false?
                                            (examination.type === 1
                                                ?<Barcode
                                                 titleMarginRight={this.state.rightMargin}
                                                 titleMarginUp={this.state.upMargin}
                                                 qrcode
                                                 key={row.id}
                                                 {...row}
                                                 examination={examination}
                                             />
                                             : <EssayBarcode
                                                 titleMarginRight={this.state.rightMargin}
                                                 titleMarginUp={this.state.upMargin}
                                                 key={row.id}
                                                 {...row}
                                                 layout={JSON.parse(JSON.stringify(examination.layout))}
                                                 examination={examination}
                                             />) :  null

                                        ,
                                    )}
                                </span>, win.document.getElementById('content'));

                                console.log("Render Done");

                                this.makeReadyToEdit(examination.paper_type,examination.title +"-"+data[0].student.school.name);
                            });
                        }}
                        onMouseUp={({target}) => target.blur()}>
                        {window.gettext('Barcodes')}
                    </button>,
                    () => <button
                        key='background-barcodes3'
                        style={{
                            ...styles.button,
                            backgroundColor: 'transparent',
                            padding: '.25em',
                            boxSizing: 'border-box',
                        }}
                        onClick={event => {
                            event.stopPropagation();
                            this.setState({
                                fontSize: 9,
                                printSize: examination.paper_type === 14 ? 'A4' : 'A5',
                                printOrientation: 'Portrait',
                            }, async () => {
                                await window.wait(500);
                                const win = this.refs.printFrame.contentWindow;
                                const response = await this.context.store.dispatch(request(
                                    '/registration/?school=' +
                                    item.id + '&examination=' + examination.id + '&limit=100000',
                                ));
                                const data = response.results.sort((a,b)=>a.student.lastname > b.student.lastname);;
                                debugger;
                                if (data.length === 0) {
                                    alert(window.gettext('No student is registered for these examinations.'));
                                    return;
                                }

                                for(var i = 0 ; i < data.length ; i++){
                                    var barcodeURL = await QRCode.toDataURL(data[i].id.toString(),{
                                        typeNumber: -1,
                                        margin: 0,
                                        errorCorrectionLevel: 'Q',
                                    });
                                    data[i].barcodeURL = barcodeURL ;
                                }

                                ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                console.log("Render 23 started");
                                let myRenderer = new Promise(function(myResolve) {
                                // "Producing Code" (May take some time)
                                    ReactDom.render(<span>
                                        {_.map(data,
                                        row =>
                                        row.online===false?
                                            (examination.type === 1
                                                ?<Barcode
                                                titleMarginRight={this.state.rightMargin}
                                                titleMarginUp={this.state.upMargin}
                                                background
                                                qrcode
                                                key={row.id}
                                                {...row}
                                                examination={examination}
                                            />
                                            : <EssayBarcode
                                                key={row.id}
                                                titleMarginRight={this.state.rightMargin}
                                                titleMarginUp={this.state.upMargin}
                                                {...row}
                                                layout={JSON.parse(JSON.stringify(examination.layout))}
                                                examination={examination}
                                            />) :  null

                                        ,
                                            )}
                                    </span>, win.document.getElementById('content'));
                                    myResolve(); // when successful
                                    //myReject();  // when error
                                });

                                myRenderer.then(onRendered.bind(this));
                                function onRendered()
                                {
                                    console.log("Render 2 Done");

                                    this.makeReadyToEdit(examination.type,examination.title +"-"+data[0].student.school.name);
                                }
                            });
                        }}
                        onMouseUp={({target}) => target.blur()}>
                        {window.gettext('Barcodes with Background')}
                    </button>,
                ],
                label: (examination.grades.length ? examination.grades[0].title : '-') + ' - ' + examination.title,
                labels: ['', '', '', ''],
            })),
        ],
    )

    schoolsFiltersSelector = schoolsFiltersSelectorGenerator.bind(this)()
    examinationsFiltersSelector = examinationsFiltersSelectorGenerator.bind(this)('students__student__registrations__examination__')

    filtersSelector = createSelector.bind(this)(
        [
            store => this.schoolsFiltersSelector(store),
            store => this.examinationsFiltersSelector(store),
        ],
        (schoolsFilters, examinationsFilters) => [
            ...schoolsFilters,
            ...examinationsFilters,
        ],
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'name', label: window.gettext('Name')},
        {name: 'city', label: window.gettext('City')},
        {name: 'region', label: window.gettext('Region')},
    ]

    examinationsSelector = createSelector(
        [
            () => this.props.store.getIn(['gradesTreeFilter', 'selected']),
            () => this.props.store.getIn(['typesTreeFilter', 'selected']),
            () => this.props.store.getIn(['stepsTreeFilter', 'selected']),
            () => this.props.store.getIn(['onlineTreeFilter', 'selected']),
            () => this.props.store.getIn(['yearsTreeFilter', 'selected']),
        ],
        async () => {
            const response = await this.context.store.dispatch(request(
                '/examination/?' + queryString.stringify({
                    grades: this.props.store.getIn(['gradesTreeFilter', 'selected']).keySeq().join(','),
                    examination_type: this.props.store.getIn(['typesTreeFilter', 'selected']).keySeq().join(','),
                    step: this.props.store.getIn(['stepsTreeFilter', 'selected']).keySeq().join(','),
                    online: this.props.store.getIn(['onlineTreeFilter', 'selected']).keySeq().join(','),
                    react__route: window.location.pathname,
                    restricted: this.props.store.getIn(['restrictedTreeFilter', 'selected']).keySeq().join(','),
                    registered: this.props.store.getIn(['registeredTreeFilter', 'selected']).keySeq().join(','),
                    date__range: this.props.store.getIn(['yearsTreeFilter', 'selected']).size
                        ? Number(this.props.store.getIn(['yearsTreeFilter', 'selected']).keySeq().sort().first().split(':')[0] / 1000 - 2678400) + ',' +
                    Number(this.props.store.getIn(['yearsTreeFilter', 'selected']).keySeq().sort().last().split(':')[1] / 1000 - 2678400) 
                        : '', 
                }),
            ));
            return response.results;
        },
    )

    editProps = {exclude: 'classes'}

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                    ]
                    : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            (__, state) => state.examinations,
            store => store.getIn(['paginator', 'selected']),
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        (examinations, schools) => this.props.readonly
            ? this.props.buttonActions
            : _.concat(
                this.props.buttonActions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        {
                             /* دکمه شیوه نامه */
                            label: window.gettext('Instructions'),
                            action: () => {
                                console.log(this.props.store);
                                this.setState({fontSize: 9, printSize: 'A4', printOrientation: 'Portrait'}, async () => {
                                    await window.wait(500);
                                    const win = this.refs.printFrame.contentWindow;
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(
                                        <span>
                                            {schools.map((school, id) => <Instructions
                                                key={id}
                                                school={this.props.store.getIn(['paginator', 'selected', id]).toJS()}
                                            />).toArray()}
                                        </span>,
                                        win.document.getElementById('content'),
                                    );
                                    win.print();  
                                });
                            },
                        },
                        /* دکمه بیجک */
                        {
                            label: window.gettext("Invoice"),
                            action: () => {
                                this.setState({fontSize: 9, printSize: 'A5', printOrientation: 'Landscape'}, async () => {
                                    await window.wait(500);
                                    const win = this.refs.printFrame.contentWindow;
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(
                                        <span>
                                            {schools.map((school, id) => <Invoice
                                                key={id}
                                                school={this.props.store.getIn(['paginator', 'selected', id])?.toJS()}
                                            />).toArray()}
                                        </span>,
                                         win.document.getElementById('content'),
                                    );
                                    
                                    win.print(); 
                                });
                            },
                        },
                        {
                            label: window.gettext('Wrapping Invoice'),
                            action: () => {
                                this.setState({fontSize: 9, printSize: 'A4', printOrientation: 'Landscape'}, async () => {
                                    await window.wait(500);
                                    const win = this.refs.printFrame.contentWindow;
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(
                                        <span>
                                            {schools.map((school, id) => _.map(examinations, examination => <WrappingInvoice
                                                key={id + '-' + examination.id}
                                                school={this.props.store.getIn(['paginator', 'selected', id]).toJS()}
                                                examination={examination}
                                            />)).toArray()}
                                        </span>,
                                        win.document.getElementById('content'),
                                    );
                                    win.print();
                                });
                            },
                        },
                        {
                            label: window.gettext('Answer Sheets'),
                            action: () => {
                                this.setState({fontSize: 9, printSize: 'A5', printOrientation: 'Portrait'}, async () => {
                                    await window.wait(500);
                                    const win = this.refs.printFrame.contentWindow;
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(
                                        <span>
                                            {schools.map((school, id) => <AnswerSheets
                                                key={id}
                                                school={this.props.store.getIn(['paginator', 'selected', id]).toJS()}
                                                examinations={examinations}
                                            />).toArray()}
                                        </span>,
                                        win.document.getElementById('content'),
                                    );
                                    win.print(); 
                                });
                            },
                        },
                        {
                            label: window.gettext('Barcodes'),
                            action: () => {
                                this.setState({
                                    fontSize: 9,
                                    printSize: examinations[0].paper_type === 14 ? 'A4' : 'A5',
                                    printOrientation: 'Portrait',
                                }, async () => {
                                    await window.wait(500);
                                    const win = this.refs.printFrame.contentWindow;
                                    const examinationsMap = _.mapKeys(examinations, examination => examination.id);
                                    const response = await this.context.store.dispatch(request(
                                        '/registration/?school=' +
                                        schools.keySeq().join(',') + '&examination=' + _.keys(examinationsMap).join(',') + '&limit=100000',
                                    ));
                                    const data = response.results.sort((a,b)=>a.student.lastname > b.student.lastname);
                                    if (data.length === 0) {
                                        alert(window.gettext('No student is registered for these examinations.'));
                                        return;
                                    }
                                    for(var i = 0 ; i < data.length ; i++){
                                        var barcodeURL = await QRCode.toDataURL(data[i].id.toString(),{
                                            typeNumber: -1,
                                            margin: 0,
                                            errorCorrectionLevel: 'Q',
                                        });
                                        data[i].barcodeURL = barcodeURL ;
                                    }
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(<span>
                                        {_.map(data,
                                        row =>
                                        row.online===false?
                                         (examinationsMap[row.examination.id].type === 1
                                             ?<Barcode
                                              titleMarginRight={this.state.rightMargin}
                                              titleMarginUp={this.state.upMargin}
                                              qrcode
                                              key={row.id}
                                              {...row}
                                              examination={examinationsMap[row.examination.id]}
                                          />
                                          : <EssayBarcode
                                              key={row.id}
                                              titleMarginRight={this.state.rightMargin}
                                              titleMarginUp={this.state.upMargin}
                                              {...row}
                                              layout={JSON.parse(JSON.stringify(examinationsMap[row.examination.id].layout))}
                                              examination={examinationsMap[row.examination.id]}
                                          />) :  null

                                     ,
                                            )}
                                    </span>, win.document.getElementById('content'));
                                    this.makeReadyToEdit(examinationsMap[data[0].examination.id].paper_type,examinationsMap[data[0].examination.id].title +"-"+data[0].student.school.name);
                                });
                            },
                        },
                        {
                            label: window.gettext('Barcodes with Background'),
                            action: () => {
                                this.setState({
                                    fontSize: 9,
                                    printSize: examinations[0].paper_type === 14 ? 'A4' : 'A5',
                                    printOrientation: 'Portrait',
                                }, async () => {
                                    await window.wait(500);
                                    const win = this.refs.printFrame.contentWindow;
                                    const examinationsMap = _.mapKeys(examinations, examination => examination.id);
                                    const response = await this.context.store.dispatch(request(
                                        '/registration/?school=' +
                                        schools.keySeq().join(',') + '&examination=' + _.keys(examinationsMap).join(',') + '&limit=100000',
                                    ));
                                    const data = response.results.sort((a,b)=>a.student.lastname > b.student.lastname);;
                                    if (data.length === 0) {
                                        alert(window.gettext('No student is registered for these examinations.'));
                                        return;
                                    }
                                    for(var i = 0 ; i < data.length ; i++){
                                        var barcodeURL = await QRCode.toDataURL(data[i].id.toString(),{
                                            typeNumber: -1,
                                            margin: 0,
                                            errorCorrectionLevel: 'Q',
                                        });
                                        data[i].barcodeURL = barcodeURL ;
                                    }
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(<span>
                                        {_.map(data,
                                        row =>
                                        row.online===false?
                                         (examinationsMap[row.examination.id].type === 1
                                             ?<Barcode
                                              titleMarginRight={this.state.rightMargin}
                                              titleMarginUp={this.state.upMargin}
                                              qrcode
                                              background
                                              key={row.id}
                                              {...row}
                                              examination={examinationsMap[row.examination.id]}
                                          />
                                          : <EssayBarcode
                                              key={row.id}
                                              titleMarginRight={this.state.rightMargin}
                                              titleMarginUp={this.state.upMargin}
                                              {...row}
                                              layout={JSON.parse(JSON.stringify(examinationsMap[row.examination.id].layout))}
                                              examination={examinationsMap[row.examination.id]}
                                          />) :  null

                                     ,
                                            )}
                                    </span>, win.document.getElementById('content'));
                                    this.makeReadyToEdit(examinationsMap[data[0].examination.id].paper_type,examinationsMap[data[0].examination.id].title +"-"+data[0].student.school.name);
                                });
                            },
                        },
                    ]
                    : []
            ),
    )
    componentDidMount(){
    }
    async componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
        this.setState({examinations: await this.examinationsSelector(this.props.store)});
    }

    render() {
        if(this.state.pageOrientation == undefined){
            this.state.pageOrientation = 'Portrait';
        }
        return <>
            
            <input
                key='pages0'
                style={{...styles.field,width:'150px',margin:10}}
                placeholder={"فاصله عناوین از راست"}
                value={this.state.rightMargin}
                onChange={({target: {value}}) =>
                    this.setState({rightMargin:(value),readyToPrint:false})
                }
            />
                
            <input
                key='pages1'
                style={{...styles.field,width:'150px',margin:10}}
                placeholder={"فاصله عناوین از بالا"}
                value={this.state.upMargin}
                onChange={({target: {value}}) =>
                    this.setState({upMargin:(value),readyToPrint:false})
                }
            />
            {this.state.readyToPrint?<>
                <button
                    key='background-barcodes0'
                    style={{
                        ...styles.button,
                        backgroundColor: '#bbffbb',
                        padding: 7.2,
                        margin:10,
                        boxSizing: 'border-box',
                    }}
                    onClick={event => {
                        this.printIframe(this.state.printType,this.state.printTitle);
                    }}
                    onMouseUp={({target}) => target.blur()}>
                        پرینت 
                </button>
                <button
                    key='background-barcodes1'
                    style={{
                        ...styles.button,
                        backgroundColor: 'transparent',
                        padding: 7.2,
                        margin:10,
                        boxSizing: 'border-box',
                    }}
                    onClick={event => {
                        this.printIframe(this.state.printType,this.state.printTitle+'_تکبرگ',1);
                    }}
                    onMouseUp={({target}) => target.blur()}>
                        پرینت تک برگ
                </button>
            </>
            :null}
            <iframe
                ref='printFrame'
                style={{width: '100%', height: '0', border: 'none'}}
                srcDoc={`<html>
                        <head>
                        <link rel="stylesheet" type="text/css" href="/css/mhelli.css">
                            <style>
                                @page {
                                    size: ${this.state.printSize} ${this.state.printOrientation};
                                    margin: 0;
                                }
                                        html, body {
                                    font-family: IRANSans;
                                    font-size: ${this.state.fontSize}pt;
                                    margin: 0;
                                    width : ${this.state.printSize === 'A4'
                            ? this.state.pageOrientation === 'Portrait' ? 210 : 297
                            : this.state.pageOrientation === 'Portrait' ? 148 : 210}mm
                                    height : ${this.state.printSize === 'A4'
                            ? this.state.pageOrientation === 'Portrait' ? 297 : 210
                            : this.state.pageOrientation === 'Portrait' ? 210 : 148}mm
                                    size: auto;
                                    direction: rtl;
                                }
                                @media print {
                                    div {
                                        -webkit-print-color-adjust: exact;
                                    }
                                }
                            </style>
                        </head>
                        <body>
                            <span id='content'><span>1</span><span style='font-weight: 700;font-family: IRANSans;'>2</span></span>
                        </body>
                    </html>`}
            />
            <div>
            <PaginatedContainer
                    store={this.props.store.get('paginator')}
                    resource='school'
                    style={this.style}
                    fixedColumns={2}
                    title={window.gettext('Schools')}
                    listFields={this.listFieldsSelector(this.props.store, this.state)}
                    selectable={this.props.selectable}
                    filters={this.filtersSelector(this.props.store)}
                    sorts={this.sorts}
                    pageSize={this.props.pageSize}
                    active={this.props.params.id}
                    actions={this.actionsSelector(this.props.store)}
                    buttonActions={this.buttonActionsSelector(this.props.store, this.state)}
                    editProps={this.editProps}
                />
            </div>
        </>
    }
}
